import React, { useEffect } from "react";
import WhatsAppButton from "./WhatsAppButton";
import GapFloat from "./GapFloat";
import FiveLayers from "./FiveLayers";

import Nav from "./sections/Nav";
import Hero from "./sections/Hero";
import IntelligenceGraphic from "./sections/IntelligenceGraphic";
import WhoWeAre from "./sections/WhoWeAre";
import StoryBanner from "./sections/StoryBanner";
import SolarChart from "./sections/SolarChart";
import StopWasteBanner from "./sections/StopWasteBanner";
import UNStatement from "./sections/UNStatement";
import Letter from "./sections/Letter";
import Pillars from "./sections/Pillars";
import Products from "./sections/Products";
import Philosophy from "./sections/Philosophy";
import Interlude from "./sections/Interlude";
import Manifesto from "./sections/Manifesto";
import EveryBuilding from "./sections/EveryBuilding";
import AudioSection from "./sections/AudioSection";
import Why from "./sections/Why";
import WhatWeDo from "./sections/WhatWeDo";
import Results from "./sections/Results";
import Beyond from "./sections/Beyond";
import Reporting from "./sections/Reporting";
import SolarGallery from "./sections/SolarGallery";
import BatteryStorage from "./sections/BatteryStorage";
import Sectors from "./sections/Sectors";
import Partners from "./sections/Partners";
import Trusted from "./sections/Trusted";
import FAQ from "./sections/FAQ";
import GapAnalysis from "./sections/GapAnalysis";
import Contact from "./sections/Contact";
import { Footer } from "./sections/Footer";

export default function MarketingSite() {
  useEffect(() => {
    const hash = window.location.hash?.replace("#", "");
    if (hash) setTimeout(() => document.getElementById(hash)?.scrollIntoView({ behavior: "smooth" }), 400);
  }, []);
  const go = (id) => {
    if (id === "top") return window.scrollTo({ top: 0, behavior: "smooth" });
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };
  return (
    <div className="evg">
      <Nav go={go} />
      <Hero go={go} />
      <IntelligenceGraphic />
      <WhoWeAre />
      <StoryBanner />
      <SolarChart />
      <StopWasteBanner />
      <UNStatement />
      <Letter />
      <Pillars />
      <Products />
      <section className="fl5-sec"><FiveLayers /></section>
      <Philosophy />
      <Interlude variant="teal">You can't eliminate what you haven't <span className="g">measured.</span></Interlude>
      <Manifesto />
      <EveryBuilding />
      <AudioSection />
      <Interlude variant="alt">Before you generate more energy, stop <span className="g">wasting the energy you already buy.</span></Interlude>
      <WhatWeDo />
      <Why />
      <Results />
      <Beyond />
      <Reporting />
      <Interlude variant="teal">Knowledge Before Investment. Eliminate Waste First. Build on Facts. Then maximise the return from <span className="g">Solar PV, Battery Storage and intelligent energy management.</span></Interlude>
      <SolarGallery go={go} />
      <BatteryStorage go={go} />
      <Sectors />
      <Partners />
      <Trusted />
      <FAQ />
      <GapAnalysis go={go} />
      <Contact />
      <Footer />
      <WhatsAppButton />
      <GapFloat />
    </div>
  );
}
